"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted/20 animate-pulse rounded-md" />
      </div>;
  }
  const filteredMenuItems = menuItems.filter(item => item.label !== "Home");
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-4 py-2 text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] hover:!bg-transparent focus:!bg-transparent hover:text-primary focus:text-foreground-dark after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full focus:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="fixed inset-0 top-16 z-50 bg-background/95 backdrop-blur-md md:hidden">
          <nav className="container mx-auto px-4 py-6">
            <ul className="flex flex-col gap-4">
              {filteredMenuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block py-2 text-lg font-medium text-foreground hover:text-primary transition-colors duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className="sticky top-0 z-50 w-full transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] h-[90px] bg-background !text-[hsl(224,76%,48%)]">
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        {}
        <Link to="#" className="flex-shrink-0">
          <img src="https://rrrecoverysolutions.com/wp-content/uploads/2026/03/Logotipo-inmobiliaria-minimalista-blanco-negro-2.png" alt="RR RECOVERY SOLUTIONS" className="h-[70px]" />
        </Link>

        {}
        <MenuProvider menu_id="46" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="hidden md:inline-flex border border-primary/30 bg-transparent text-primary hover:bg-primary hover:text-foreground-primary hover:!bg-primary focus:!bg-primary hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]">
          <Link to="#free-funds-search" className="hover:!bg-transparent focus:!bg-transparent">
            Get Started
          </Link>
        </Button>
      </div>
    </header>;
}